import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { TitleProps } from './types';

const Title = (props: TitleProps) => {
  const { plainTitle, highlightedTitle } = props;
  return (
    <h2
      className={ivclass(
        'iv-text-center md:iv-text-left lg:iv-text-left xl:iv-text-left',
        'iv-m-heading-s md:iv-m-heading-2xl lg:iv-m-heading-4xl xl:iv-m-heading-5xl',
        'iv-text-heading-s md:iv-text-heading-2xl lg:iv-text-heading-4xl xl:iv-text-heading-5xl',
        'iv-font-extrabold',
      )}
    >
      <span>{plainTitle.line1}</span>
      <span className={ivclass('iv-block sm:iv-inline')}>
        <span>{plainTitle.line2}</span>
        <span className={ivclass('iv-text-gradient-green')}>
          {highlightedTitle}
        </span>
      </span>
    </h2>
  );
};

export default Title;
